/* Pave Tool product summaries | v3.2. Preserve scrolling/positioning; clip mobile panel at sticky header. */
(function () {
  'use strict';
  const widgetSelector = '[data-pt-quick-summary]';
  const buttonSelector = '.pt-quick-summary__trigger';
  const panelSelector = '.pt-quick-summary__panel';
  const mobile = window.matchMedia('(max-width: 767px)');
  let active = null;
  let searchActive = false;
  let nextId = 0;

  function restorePanel(widget) {
    if (!widget) return;
    const panel = document.querySelector('[data-pt-summary-portaled="' + widget.dataset.ptSummaryId + '"]');
    if (panel) {
      panel.classList.remove('pt-quick-summary__panel--mobile');
      panel.style.left = '';
      panel.style.top = '';
      panel.style.width = '';
      panel.style.clipPath = '';
      panel.removeAttribute('data-pt-summary-portaled');
      widget.appendChild(panel);
    }
  }

  function close() {
    if (!active) return;
    const widget = active;
    active = null;
    restorePanel(widget);
    const button = widget.querySelector(buttonSelector);
    const panel = widget.querySelector(panelSelector);
    if (button) button.setAttribute('aria-expanded', 'false');
    if (panel) panel.hidden = true;
    widget.classList.remove('is-open');
  }

  function findPanel(widget) {
    return widget.querySelector(panelSelector) ||
      document.querySelector('[data-pt-summary-portaled="' + widget.dataset.ptSummaryId + '"]');
  }

  function positionMobilePanel(widget, panel) {
    const button = widget.querySelector(buttonSelector);
    if (!button) return;
    const rect = button.getBoundingClientRect();
    const gap = 8;
    const margin = 12;
    const viewportWidth = document.documentElement.clientWidth || window.innerWidth;
    const width = Math.min(320, viewportWidth - margin * 2);
    const left = Math.min(Math.max(margin, rect.right - width), viewportWidth - width - margin);
    panel.style.width = width + 'px';
    panel.style.left = (left + window.scrollX) + 'px';

    // Position in PAGE coordinates, not viewport coordinates.
    // This lets the popup move naturally with its product card as the page scrolls.
    const panelHeight = panel.getBoundingClientRect().height;
    const below = rect.bottom + gap;
    const above = rect.top - panelHeight - gap;
    const top = (below + panelHeight <= window.innerHeight - margin || above < margin)
      ? below : above;
    panel.style.top = (top + window.scrollY) + 'px';
  }

  // The mobile panel is appended to <body> to avoid being clipped by
  // neighboring product cards. Because it is outside the card's stacking
  // context, a small z-index alone cannot reliably place it behind a sticky
  // header. Clip any portion that scrolls under the header instead.
  function clipMobilePanelToHeader(panel) {
    if (!panel || !mobile.matches) return;
    const headers = document.querySelectorAll([
      '#shopify-section-header',
      '.shopify-section-header',
      '.header-sticky-wrapper',
      '.site-header-sticky',
      '#SiteHeader',
      '.site-header',
      '[data-sticky-header]',
      'header[role="banner"]'
    ].join(','));
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    let headerBottom = 0;

    headers.forEach(function (header) {
      const rect = header.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top > 120 || rect.height <= 0 ||
          rect.height > viewportHeight * 0.6 || rect.bottom > viewportHeight * 0.6) return;
      const style = window.getComputedStyle(header);
      if (style.display === 'none' || style.visibility === 'hidden') return;
      headerBottom = Math.max(headerBottom, rect.bottom);
    });

    const panelRect = panel.getBoundingClientRect();
    const hiddenTop = Math.max(0, Math.min(panelRect.height,
      Math.ceil(headerBottom - panelRect.top + 1)));
    panel.style.clipPath = hiddenTop > 0
      ? 'inset(' + hiddenTop + 'px 0px 0px 0px)'
      : '';
  }

  function open(widget) {
    if (!widget || searchActive) return;
    if (!widget.dataset.ptSummaryId) widget.dataset.ptSummaryId = "pt-summary-" + (++nextId);
    if (active === widget) return;
    close();
    const button = widget.querySelector(buttonSelector);
    const panel = widget.querySelector(panelSelector);
    if (!button || !panel) return;
    active = widget;
    widget.classList.add('is-open');
    button.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    if (mobile.matches) {
      // Portaling the panel prevents card clipping; absolute page coordinates keep natural scrolling.
      panel.classList.add('pt-quick-summary__panel--mobile');
      panel.dataset.ptSummaryPortaled = widget.dataset.ptSummaryId;
      document.body.appendChild(panel);
      positionMobilePanel(widget, panel);
      clipMobilePanelToHeader(panel);
    }
  }

  function isSearchElement(element) {
    if (!element || !element.closest) return false;
    return !!element.closest('input[type="search"], input[name="q"], [role="searchbox"], .site-header__search-btn, .js-search-header, [aria-label="Search"], [data-search-toggle]');
  }

  function searchOverlayVisible() {
    const selectors = [
      '.site-header__search-container.is-active',
      '.site-header__search-container--is-active',
      '.search-modal[open]', '.search-modal.is-open',
      '.predictive-search[open]', '.predictive-search.is-open',
      '[data-predictive-search].is-active',
      '.site-header__search.is-active'
    ];
    return selectors.some(function (selector) {
      return Array.from(document.querySelectorAll(selector)).some(function (el) {
        const css = window.getComputedStyle(el);
        return css.display !== 'none' && css.visibility !== 'hidden' && el.getBoundingClientRect().width > 0;
      });
    });
  }

  function updateSearchState() {
    const focused = document.activeElement;
    const searchFocused = focused && focused.matches &&
      focused.matches('input[type="search"], input[name="q"], [role="searchbox"]') &&
      !!focused.closest('header, .site-header, .search-modal, .search-drawer, [role="dialog"], .predictive-search');
    searchActive = !!searchFocused || searchOverlayVisible();
    document.body.classList.toggle('pt-summary-search-active', searchActive);
    if (searchActive) close();
  }

  document.addEventListener('click', function (event) {
    const button = event.target.closest(buttonSelector);
    if (button) {
      event.preventDefault();
      event.stopPropagation();
      if (searchActive) return;
      const widget = button.closest(widgetSelector);
      if (active === widget) close(); else open(widget);
    } else if (!event.target.closest(panelSelector) && !event.target.closest(widgetSelector)) {
      close();
    }
    if (isSearchElement(event.target)) {
      close();
      requestAnimationFrame(updateSearchState);
    }
  }, true);

  const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');
  document.addEventListener('pointerover', function (event) {
    if (!hoverCapable.matches || searchActive) return;
    const widget = event.target.closest(widgetSelector);
    if (!widget || (event.relatedTarget && widget.contains(event.relatedTarget))) return;
    open(widget);
  });
  document.addEventListener('pointerout', function (event) {
    if (!hoverCapable.matches || !active) return;
    const widget = event.target.closest(widgetSelector);
    if (widget !== active) return;
    const next = event.relatedTarget;
    if (!next || (!widget.contains(next) && !findPanel(widget)?.contains(next))) {
      if (!widget.contains(document.activeElement)) close();
    }
  });
  document.addEventListener('focusin', function (event) {
    if (isSearchElement(event.target)) {
      close();
      requestAnimationFrame(updateSearchState);
    }
  });
  document.addEventListener('focusout', function () {
    requestAnimationFrame(updateSearchState);
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && active) {
      const button = active.querySelector(buttonSelector);
      close();
      button?.focus();
    }
  });
  // Mobile Safari may fire resize when its address bar expands/collapses while scrolling.
  // Never close a summary merely because the browser chrome changed height.
  let lastViewportWidth = document.documentElement.clientWidth;
  window.addEventListener('resize', function () {
    const width = document.documentElement.clientWidth;
    if (width === lastViewportWidth) return;
    lastViewportWidth = width;
    if (!active) return;
    if (!mobile.matches) { close(); return; }
    const panel = findPanel(active);
    if (panel) {
      positionMobilePanel(active, panel);
      clipMobilePanelToHeader(panel);
    }
  }, { passive: true });

  // Let the popup scroll with the card, but mask the area covered by the
  // sticky navigation instead of closing the popup or leaving it above the nav.
  window.addEventListener('scroll', function () {
    if (!active || !mobile.matches) return;
    clipMobilePanelToHeader(findPanel(active));
  }, { passive: true });

  // Search overlays frequently update classes after the initial click.
  let scheduled = false;
  const observer = new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      updateSearchState();
    });
  });
  observer.observe(document.documentElement, {
    attributes: true, attributeFilter: ['class', 'aria-expanded', 'aria-hidden', 'open'],
    childList: true, subtree: true
  });
  // Lazy IDs in open() also cover AJAX-generated search and collection cards.
  updateSearchState();
})();
